const getIsErrorVisible = ({ schedulingGroups }) =>
  schedulingGroups.showNameError;

export default getIsErrorVisible;
